import React, { useEffect } from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import WhyAttend from '../components/WhyAttend';
import WhatYoullLearn from '../components/WhatYoullLearn';
import WhoShouldAttend from '../components/WhoShouldAttend';
import Takeaways from '../components/Takeaways';
import AboutEnculture from '../components/AboutEnculture';
import FinalCTA from '../components/FinalCTA';
import Footer from '../components/Footer';

const HomePage = () => {
  useEffect(() => {
    // Smooth scrolling for anchor links
    const handleAnchorClick = (e) => {
      if (e.target.tagName === 'A' && e.target.getAttribute('href')?.startsWith('#')) {
        e.preventDefault();
        const targetId = e.target.getAttribute('href').substring(1);
        const targetElement = document.getElementById(targetId);
        if (targetElement) {
          targetElement.scrollIntoView({
            behavior: 'smooth'
          });
        }
      }
    };

    document.addEventListener('click', handleAnchorClick);
    
    return () => {
      document.removeEventListener('click', handleAnchorClick);
    };
  }, []);

  return (
    <div>
      <Header />
      <Hero />
      <WhyAttend />
      <WhatYoullLearn />
      <WhoShouldAttend />
      <Takeaways />
      <AboutEnculture />
      <FinalCTA />
      <Footer />
    </div>
  );
};

export default HomePage;
